module.exports = __webpack_public_path__ + "img/sucess-icon.a6dfcb1a.svg";